export default "__VITE_ASSET__CURhMyyx__"